import {
  loadCalendarModule,
  loadEmailModule,
  loadListsModule,
  loadListViewModule,
} from '@/platform/performance/homeNavigation';
import {
  loadCanvasModule,
  loadClinicalTrialsModule,
  loadHomeModule,
  loadPatientModule,
  loadPhoneModule,
  loadSettingsModule,
} from '@/platform/performance/viewModules';
import { preloadAppShell } from '@/platform/components/appShellModules';
import { withCatalogs } from '@/i18n/catalogs';

export const loadRudiPanelModule = withCatalogs(
  [
    'calendar',
    'canvas',
    'chat',
    'clinicalTrials',
    'docs',
    'email',
    'feasibility',
    'lists',
    'meetingCapture',
    'meetingOutputs',
    'platform',
    'publicBooking',
    'settings',
    'teamChat',
    'training',
    'vaultItems',
    'video',
    'voice',
  ],
  () => import('@/platform/components/Rudi/Rudi')
);
export const loadRudiEmailViewModule = withCatalogs(
  ['calendar', 'email', 'feasibility', 'platform'],
  () => import('@/platform/components/Rudi/RudiEmailView')
);

// The cached loaders TabContent reads, so a view preloaded here renders
// without waiting (see platform/lib/cachedModule.ts).
const initialViewLoaders: Record<string, () => Promise<unknown>> = {
  home: loadHomeModule,
  patients: loadPatientModule,
  'clinical-trials': loadClinicalTrialsModule,
  calendar: loadCalendarModule,
  canvas: loadCanvasModule,
  email: loadEmailModule,
  lists: loadListsModule,
  'lists-detail': loadListViewModule,
  phone: loadPhoneModule,
  settings: loadSettingsModule,
};

export function initialViewForPathname(pathname: string): string | null {
  const segments = pathname.split('/').filter(Boolean);
  return segments.find(segment => Object.hasOwn(initialViewLoaders, segment)) ?? null;
}

export function initialViewModuleForPathname(pathname: string): string | null {
  const appSegment = initialViewForPathname(pathname);
  if (appSegment !== 'lists') return appSegment;

  const segments = pathname.split('/').filter(Boolean);
  const listsIndex = segments.indexOf('lists');
  return listsIndex >= 0 && segments.length > listsIndex + 1 ? 'lists-detail' : 'lists';
}

/** Start only the view chunk named by the initial URL, and the shell around it. */
export function preloadInitialView(pathname: string): void {
  const moduleKey = initialViewModuleForPathname(pathname);
  if (!moduleKey) return;
  preloadAppShell();

  void initialViewLoaders[moduleKey]().catch(error => {
    console.warn(`[initialViewPreload] ${moduleKey} preload failed`, error);
  });
}
